import moment from 'moment'
import { Currency } from '../models'

/* eslint-disable complexity */
const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const monthIsMissing = (monthBefore: any, monthAfter: any) => {
  const m1 = monthNames.indexOf(monthBefore)
  const m2 = monthNames.indexOf(monthAfter)
  if (m1 === 11) {
    if (m2 === 0) {
      return { 'valid': true }
    } else {
      return { 'valid': false, 'month': monthNames[0] }
    }
  } else if ((m1 + 1) === m2) {
    return { 'valid': true }
  } else {
    return { 'valid': false, 'month': monthNames[m1 + 1] }
  }
}

export const getMonthFromDate = (fecha: any) => {
  const date = new Date(fecha)
  const month = date.getMonth()
  return monthNames[month]
}

export const purchasesDateFormatDashboard = (purchases: any, purchase_type = 'type', eje_y = '') => {
  const purchasesMonthParsed = purchases.map(purchase => ({ ...purchase, month: getMonthFromDate(purchase.month) }))
  const finalPurchases = []
  for (let x = 0; x < purchasesMonthParsed.length; x++) {
    for (const i in purchasesMonthParsed[x]) {
      if (!isNaN(purchasesMonthParsed[x][i])) {
        purchasesMonthParsed[x][i] = parseFloat(purchasesMonthParsed[x][i].toFixed(2))
      }
    }
  }
  for (let x = 0; x < purchasesMonthParsed.length; x++) {
    const month = purchasesMonthParsed[x].month
    if (x > 0) {
      const monthBefore = purchasesMonthParsed[x - 1].month
      const result = monthIsMissing(monthBefore, month)
      if (result.valid === false) {
        finalPurchases.push({
          month: result.month,
          type: purchase_type,
          total_entries: 0,
          total_amount_eur: 0,
          total_amount_usd: 0,
          total_tCO2e: 0,
          eje_x: result.month,
          eje_y: 0
        })
      }
    }
    if (eje_y !== '') {
      finalPurchases.push({
        eje_x: month,
        type: purchase_type,
        total_entries: purchases[x].total_entries,
        total_amount_eur: purchases[x].total_amount_eur,
        total_amount_usd: purchases[x].total_amount_usd,
        total_tCO2e: purchases[x].total_tCO2e,
        eje_y: purchases[x][eje_y]
      })
    } else {
      finalPurchases.push(purchasesMonthParsed[x])
    }
  }
  let todayMonth = new Date(Date.now()).getMonth()
  const last12Months = []
  for (let i = 0; i < 12; i++) {
    last12Months.push(monthNames[todayMonth])
    todayMonth++
    if (todayMonth > 11) {
      todayMonth = 0
    }
  }
  last12Months.push(last12Months.shift())
  let allFinalPurchases = []
  if (finalPurchases.length < 12) {
    for (let x = 0; x < last12Months.length; x++) {
      let isMonth = false
      for (const i of finalPurchases) {
        if (i.eje_x === last12Months[x]) {
          isMonth = true
          allFinalPurchases.push(i)
        }
      }
      if (!isMonth) {
        allFinalPurchases.push({
          month: last12Months[x],
          type: purchase_type,
          total_entries: 0,
          total_amount_eur: 0,
          total_amount_usd: 0,
          total_tCO2e: 0,
          eje_y: 0,
          eje_x: last12Months[x]
        })
      }
    }
  } else {
    allFinalPurchases = finalPurchases
  }
  return {
    finalPurchases: allFinalPurchases
  }
}
export const getCurrencyToken = (currencyList: Currency[], currencySymbol: string) => {
  return currencyList.find(token => token.code === currencySymbol)?.id
}

export const extractFormData = (data: object): FormData => {
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    if (data[key] || data[key] === '') {
      formData.append(key, data[key])
    }
  })
  return formData
}

export const prepareChart = ({
  salesData, filter, t, getRate, ordersData, isProjectDeveloperUser, setConfig
}: any): any => {
  let data = []
  let dataDetails = {}
  const sales = salesData
  if (sales === undefined || sales === null) {
    return
  }
  let count = 0
  let today = new Date(Date.now())
  today.setHours(0, 0, 0, 0)
  const sevenDaysAgo = today
  sevenDaysAgo.setDate(today.getDate() - filter)
  let currentDay = sevenDaysAgo
  for (const sale of sales) {
    const saleDate = new Date(sale.day)
    saleDate.setHours(0, 0, 0, 0)
    currentDay.setHours(0, 0, 0, 0)
    while ((saleDate.getTime() !== currentDay.getTime()) && count < 365) {
      const newSale = {
        eje_x: currentDay.getFullYear() + '/' + (+currentDay.getMonth() + 1) + '/' + currentDay.getDate(),
        type: t('Sales'),
        eje_y: 0
      }
      data.push(newSale)
      currentDay.setDate(currentDay.getDate() + 1)
      count++
    }
    currentDay.setDate(currentDay.getDate() + 1)
    const newSale = {
      eje_x: saleDate.getFullYear() + '/' + (saleDate.getMonth() + 1) + '/' + saleDate.getDate(),
      type: t('Sales'),
      eje_y: sale.total_tCO2e
    }
    data.push(newSale)
  }
  count = 0
  today = new Date(Date.now())
  today.setHours(0, 0, 0, 0)
  while (currentDay.getTime() <= today.getTime() && count < 365) {
    const newSale = {
      eje_x: currentDay.getFullYear() + '/' + (+currentDay.getMonth() + 1) + '/' + currentDay.getDate(),
      type: t('Sales'),
      eje_y: 0
    }
    data.push(newSale)
    currentDay.setDate(currentDay.getDate() + 1)
    count++
  }
  const orders = ordersData
  sevenDaysAgo.setDate(today.getDate() - filter)
  currentDay = sevenDaysAgo
  today = new Date(Date.now())
  today.setHours(0, 0, 0, 0)
  count = 0
  for (const order of orders) {
    const orderDate = new Date(order.day)
    orderDate.setHours(0, 0, 0, 0)
    currentDay.setHours(0, 0, 0, 0)
    while (orderDate.getTime() !== currentDay.getTime() && count < 365) {
      const newOrder = {
        eje_x: currentDay.getFullYear() + '/' + (+currentDay.getMonth() + 1) + '/' + currentDay.getDate(),
        type: t('Orders'),
        eje_y: 0
      }
      data.push(newOrder)
      currentDay.setDate(currentDay.getDate() + 1)
      count++
    }
    currentDay.setDate(currentDay.getDate() + 1)
    const newOrder = {
      eje_x: orderDate.getFullYear() + '/' + (orderDate.getMonth() + 1) + '/' + orderDate.getDate(),
      type: t('Orders'),
      eje_y: order.total_tCO2e
    }
    data.push(newOrder)
  }
  count = 0
  while (currentDay.getTime() <= today.getTime() && count < 365) {
    const newSale = {
      eje_x: currentDay.getFullYear() + '/' + (+currentDay.getMonth() + 1) + '/' + currentDay.getDate(),
      type: t('Orders'),
      eje_y: 0
    }
    data.push(newSale)
    currentDay.setDate(currentDay.getDate() + 1)
    count++
  }
  let ordersTotalTCO2E = 0
  let ordersTotalEUR = 0
  let ordersTotalUSD = 0
  let salesTotalTCO2E = 0
  let salesTotalEUR = 0
  let salesTotalUSD = 0
  for (const i of sales) {
    salesTotalTCO2E += i.total_tCO2e
    salesTotalEUR += i.total_amount_eur + (i.total_amount_usd * getRate('EUR'))
    salesTotalUSD += i.total_amount_usd + (i.total_amount_eur * getRate('USD'))
  }
  for (const i of orders) {
    ordersTotalTCO2E += i.total_tCO2e
    ordersTotalEUR += i.total_amount_eur + (i.total_amount_usd * getRate('EUR'))
    ordersTotalUSD += i.total_amount_usd + (i.total_amount_eur * getRate('USD'))
  }
  dataDetails = { salesTotalTCO2E, salesTotalEUR, salesTotalUSD, ordersTotalTCO2E, ordersTotalEUR, ordersTotalUSD }
  const newData = JSON.parse(JSON.stringify(data))
  for (const i of newData) {
    i.eje_x = moment(i.eje_x).format('YYYY/MM/DD')
  }
  data = isProjectDeveloperUser ? newData : newData.filter(item => item.type === 'Orders')
  setConfig({
    data: data,
    xField: 'eje_x',
    yField: 'eje_y',
    seriesField: 'type',
    smooth: true
  })
  return {
    data,
    dataDetails,
    loadChart: false
  }
}

export const prepareMonthChart = ({
  salesData, t, ordersData, isProjectDeveloperUser, setConfig, getRate
}: any): any => {
  let data = []
  let dataDetails = {}
  const newSales = JSON.parse(JSON.stringify(purchasesDateFormatDashboard(salesData, t('Sales'), 'total_tCO2e'))).finalPurchases
  const newOrders = JSON.parse(JSON.stringify(purchasesDateFormatDashboard(ordersData, t('Orders'), 'total_tCO2e'))).finalPurchases
  if(isProjectDeveloperUser){ data = [...newOrders, ...newSales] }
  else { data = [...newOrders] }
  let ordersTotalTCO2E = 0
  let ordersTotalEUR = 0
  let ordersTotalUSD = 0
  let salesTotalTCO2E = 0
  let salesTotalEUR = 0
  let salesTotalUSD = 0
  for (const i of newSales) {
    salesTotalTCO2E += i.total_tCO2e
    salesTotalEUR += i.total_amount_eur + (i.total_amount_usd * getRate('EUR'))
    salesTotalUSD += i.total_amount_usd + (i.total_amount_eur * getRate('USD'))
  }
  for (const i of newOrders) {
    ordersTotalTCO2E += i.total_tCO2e
    ordersTotalEUR += i.total_amount_eur + (i.total_amount_usd * getRate('EUR'))
    ordersTotalUSD += i.total_amount_usd + (i.total_amount_eur * getRate('USD'))
  }
  dataDetails = { salesTotalTCO2E, salesTotalEUR, salesTotalUSD, ordersTotalTCO2E, ordersTotalEUR, ordersTotalUSD }
  setConfig({
    data: data,
    xField: 'eje_x',
    yField: 'eje_y',
    seriesField: 'type',
    smooth: true
  })
  return {
    data,
    dataDetails,
    loadChart: false
  }
}
